"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Question = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const InputLoading_1 = __importDefault(require("../inputs/InputLoading"));
const InputString_1 = __importDefault(require("../inputs/InputString"));
const InputMapPoint_1 = __importDefault(require("../inputs/InputMapPoint"));
const InputMapFindPlace_1 = __importDefault(require("../inputs/InputMapFindPlace"));
// TODO Support find place with photon
// import InputMapFindPlacePhotonOsm from './input/InputMapFindPlacePhotonOsm';
const InputDatePicker_1 = __importDefault(require("../inputs/InputDatePicker"));
const InputRadio_1 = __importDefault(require("../inputs/InputRadio"));
const InputCheckbox_1 = __importDefault(require("../inputs/InputCheckbox"));
const InputRange_1 = __importDefault(require("../inputs/InputRange"));
const InputButton_1 = __importDefault(require("../inputs/InputButton"));
const InputSelect_1 = __importDefault(require("../inputs/InputSelect"));
const InputMultiselect_1 = __importDefault(require("../inputs/InputMultiselect"));
const InputTime_1 = __importDefault(require("../inputs/InputTime"));
const InputRadioNumber_1 = __importDefault(require("../inputs/InputRadioNumber"));
const InputText_1 = __importDefault(require("../inputs/InputText"));
const react_modal_1 = __importDefault(require("react-modal"));
const utils_1 = require("../../actions/utils");
const WithSurveyContextHoc_1 = require("../hoc/WithSurveyContextHoc");
const types_1 = require("evolution-common/lib/services/questionnaire/types");
const types_2 = require("evolution-common/lib/services/questionnaire/types");
const InputWidgetWrapper_1 = __importDefault(require("./widgets/InputWidgetWrapper"));
// Make sure Modal knows what DOM element is the app container. Available examples in the package documentation all put this line outside the component.
if (!process.env.IS_TESTING) {
    react_modal_1.default.setAppElement('#app');
}
class Question extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.inputRef = react_1.default.createRef();
        this.closeModal = (e) => {
            if (e) {
                e.preventDefault();
            }
            this.setState({ modalIsOpen: false });
        };
        //afterOpenHelperModal() {
        //  // references are now sync'd and can be accessed.
        //}
        this.onValueChange = (e, customValue) => {
            if (e && e.stopPropagation) {
                e.stopPropagation();
                //e.persist(); // for debounce
            }
            const widgetStatus = this.props.widgetStatus;
            const widgetConfig = this.props.widgetConfig;
            const previousValue = widgetStatus.value;
            const previousCustomValue = widgetStatus.customValue;
            const value = e.target ? e.target.value : e; //InputDatePicker call onValueChange with e=value
            const parsedValue = surveyHelper.parseValue(value, widgetConfig.datatype, (0, types_2.isInputTypeWithArrayValue)(widgetConfig.inputType));
            const parsedCustomValue = surveyHelper.parseValue(customValue, widgetConfig.customDatatype);
            const [isValid] = (0, utils_1.checkValidations)(widgetConfig.validations, parsedValue, parsedCustomValue, this.props.interview, this.props.path, this.props.customPath);
            const valuesByPath = {};
            let userAction = undefined;
            if (!(0, isEqual_1.default)(parsedValue, previousValue) && !(parsedValue === null && previousValue === undefined)) {
                valuesByPath['validations.' + this.props.path] = isValid;
                userAction = {
                    type: 'widgetInteraction',
                    widgetType: widgetConfig.inputType,
                    path: 'response.' + this.props.path,
                    value: parsedValue
                };
            }
            if (this.props.customPath &&
                !(0, isEqual_1.default)(parsedCustomValue, previousCustomValue) &&
                !(parsedCustomValue === null && previousCustomValue === undefined)) {
                valuesByPath['validations.' + this.props.customPath] = isValid;
                if (userAction === undefined) {
                    userAction = {
                        type: 'widgetInteraction',
                        widgetType: 'string',
                        path: 'response.' + this.props.customPath,
                        value: parsedCustomValue
                    };
                }
                else {
                    console.warn('userAction already defined, but a custom value has been specified. It is thus possible to update more than one value for a single user action.');
                    valuesByPath['response.' + this.props.customPath] = parsedCustomValue;
                }
            }
            if (userAction !== undefined || this.props.widgetConfig.inputType === 'button') {
                // force update with buttons
                let saveCallback = undefined;
                if (isValid && typeof widgetConfig.saveCallback === 'function') {
                    saveCallback = widgetConfig.saveCallback;
                }
                this.props.startUpdateInterview({ valuesByPath, userAction }, saveCallback);
            }
            if ((0, types_1.isWidgetModal)(widgetConfig) && this.state.modalIsOpen && isValid) {
                this.closeModal();
            }
        };
        this.state = {
            modalIsOpen: (0, types_1.isWidgetModal)(props.widgetConfig) && props.widgetStatus.isVisible === true
        };
    }
    shouldComponentUpdate(nextProps, _nextState) {
        // we need to re-render whenever loading state changes for widgets with buttons, like mapFindPlace:
        // TODO: find all buttons inside questions to make sure they are correctly re-render before click event is triggered.
        // See Button.js for more comments about this issue
        return nextProps.widgetConfig.inputType === 'mapFindPlace' || nextProps.loadingState === 0;
    }
    render() {
        const widgetStatus = this.props.widgetStatus;
        if (!widgetStatus.isVisible && !this.props.surveyContext.devMode) {
            return null;
        }
        // We're here, if the widget is not visible, we're in devMode, so disable it
        const disabled = !widgetStatus.isVisible;
        surveyHelper.devLog('%c rendering question ' + this.props.path, 'background: rgba(255,255,0,0.1); font-size: 7px;');
        const id = `survey-question__${this.props.path}`;
        const widgetConfig = this.props.widgetConfig;
        const inputType = this.props.widgetConfig.inputType;
        const label = surveyHelper.translateString(widgetConfig.label, this.props.i18n, this.props.interview, this.props.path, this.props.user) || '';
        const twoColumns = typeof widgetConfig.twoColumns === 'function'
            ? widgetConfig.twoColumns(this.props.interview, this.props.path)
            : widgetConfig.twoColumns;
        const showErrorMessage = widgetStatus.isResponded === true &&
            widgetStatus.isValid === false &&
            !disabled &&
            widgetStatus.errorMessage
            ? true
            : false;
        const widgetContent = () => {
            if (!(this.props.interview && this.props.interview.response)) {
                return react_1.default.createElement(InputLoading_1.default, null);
            }
            const commonProps = {
                interview: this.props.interview,
                path: this.props.path,
                user: this.props.user,
                id,
                onValueChange: this.onValueChange,
                // TODO Have the right inputRef type
                inputRef: this.inputRef
            };
            switch (widgetConfig.inputType) {
                case 'string':
                    return (react_1.default.createElement(InputString_1.default, Object.assign({}, commonProps, { widgetConfig: widgetConfig, updateKey: widgetStatus.currentUpdateKey, value: widgetStatus.value })));
                case 'mapPoint':
                    return (react_1.default.createElement(InputMapPoint_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                case 'mapFindPlace':
                    return (react_1.default.createElement(InputMapFindPlace_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, loadingState: this.props.loadingState, widgetConfig: widgetConfig })));
                case 'radio':
                    return (react_1.default.createElement(InputRadio_1.default, Object.assign({}, commonProps, { customValue: widgetStatus.customValue, value: widgetStatus.value, customPath: this.props.customPath, customId: this.props.customPath ? `survey-question__${this.props.customPath}` : undefined, widgetConfig: widgetConfig })));
                case 'radioNumber':
                    return (react_1.default.createElement(InputRadioNumber_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                case 'checkbox':
                    return (react_1.default.createElement(InputCheckbox_1.default, Object.assign({}, commonProps, { customValue: widgetStatus.customValue, value: widgetStatus.value, customId: this.props.customPath ? `survey-question__${this.props.customPath}` : undefined, widgetConfig: widgetConfig })));
                case 'button':
                    return (react_1.default.createElement(InputButton_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                case 'select':
                    return (react_1.default.createElement(InputSelect_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                case 'multiselect':
                    return (react_1.default.createElement(InputMultiselect_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                case 'time':
                    return (react_1.default.createElement(InputTime_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                case 'text':
                    return react_1.default.createElement(InputText_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig }));
                case 'datePicker':
                    return (react_1.default.createElement(InputDatePicker_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                case 'slider':
                    return (react_1.default.createElement(InputRange_1.default, Object.assign({}, commonProps, { value: widgetStatus.value, widgetConfig: widgetConfig })));
                default:
                    return (react_1.default.createElement(InputString_1.default, Object.assign({}, commonProps, commonProps, { widgetConfig: widgetConfig, updateKey: widgetStatus.currentUpdateKey, value: widgetStatus.value })));
            }
        };
        const content = (react_1.default.createElement("div", { key: 'content_' + this.props.path, style: { position: 'relative' }, className: `apptr__form-container${this.props.join ? ' apptr__form-join-next' : ''}${twoColumns ? ' two-columns' : ''}${widgetStatus.isDisabled || disabled ? ' disabled' : ''} question-type-${inputType}${widgetStatus.isEmpty ? ' question-empty' : ' question-filled'}${!widgetStatus.isEmpty && widgetStatus.isValid === true
                ? ' question-valid'
                : showErrorMessage === true
                    ? ' question-invalid'
                    : ''}`, onClick: () => {
                if (this.inputRef.current && typeof this.inputRef.current.focus === 'function') {
                    this.inputRef.current.focus();
                }
            } },
            react_1.default.createElement(InputWidgetWrapper_1.default, { label: label, errorMessage: showErrorMessage === true
                    ? surveyHelper.translateString(widgetStatus.errorMessage, this.props.i18n, this.props.interview, this.props.path) || ''
                    : undefined, helpTitle: widgetConfig.helpPopup && widgetConfig.helpPopup.title
                    ? surveyHelper.translateString(widgetConfig.helpPopup.title, this.props.i18n, this.props.interview, this.props.path) || ''
                    : undefined, helpContent: widgetConfig.helpPopup && widgetConfig.helpPopup.content
                    ? () => {
                        var _a;
                        return surveyHelper.translateString((_a = widgetConfig.helpPopup) === null || _a === void 0 ? void 0 : _a.content, this.props.i18n, this.props.interview, this.props.path) || '';
                    }
                    : undefined, widgetConfig: widgetConfig, isCollapsed: widgetStatus.isCollapsed, className: `apptr__form-label-container${twoColumns ? ' two-columns' : ''}${widgetConfig.align === 'center' ? ' align-center' : ''}`, widgetId: id }, (!widgetStatus.isDisabled ||
                (widgetStatus.isDisabled && !widgetConfig.canBeCollapsed)) && (react_1.default.createElement("div", { className: `apptr__form-input-container ${twoColumns ? 'two-columns' : ''}` }, widgetContent())))));
        if ((0, types_1.isWidgetModal)(widgetConfig)) {
            if (!this.state.modalIsOpen) {
                return null;
            }
            return (react_1.default.createElement(react_modal_1.default, { isOpen: true, onRequestClose: () => this.closeModal(), className: "react-modal", overlayClassName: "react-modal-overlay", contentLabel: widgetConfig.title || '' }, content));
        }
        else {
            return content;
        }
    }
}
exports.Question = Question;
exports.default = (0, react_i18next_1.withTranslation)()((0, WithSurveyContextHoc_1.withSurveyContext)(Question));
//# sourceMappingURL=Question.js.map